import { EmailsApi } from 'src/orchd-client';

import { axiosInstance } from 'src/utils/axios';

export const emailsApi = EmailsApi({}, '/api', axiosInstance);
